import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Login from './components/Login';
import AdminLayout from './components/AdminLayout';
import Dashboard from './components/Dashboard';
import UsersManagement from './components/UsersManagement';
import GamesManagement from './components/GamesManagement';
import Analytics from './components/Analytics';
import Settings from './components/Settings';
import Support from './components/Support';
import Moderation from './components/Moderation';
import Tournaments from './components/Tournaments';
import ProductsManagement from './components/ProductsManagement';
import CoinsManagement from './components/CoinsManagement';
import PaymentsManagement from './components/PaymentsManagement';
import CustomizationManagement from './components/CustomizationManagement';
import AudioManagement from './components/AudioManagement';
import Notifications from './components/Notifications';
import Profile from './components/Profile';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import { Toaster } from 'react-hot-toast';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <Router>
            <div className="App">
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminLayout />
                    </ProtectedRoute>
                  }
                >
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="users" element={<UsersManagement />} />
                  <Route path="games" element={<GamesManagement />} />
                  <Route path="analytics" element={<Analytics />} />
                  <Route path="settings" element={<Settings />} />
                  <Route path="support" element={<Support />} />
                  <Route path="moderation" element={<Moderation />} />
                  <Route path="tournaments" element={<Tournaments />} />
                  <Route path="products" element={<ProductsManagement />} />
                  <Route path="coins" element={<CoinsManagement />} />
                  <Route path="payments" element={<PaymentsManagement />} />
                  <Route path="customization" element={<CustomizationManagement />} />
                  <Route path="audio" element={<AudioManagement />} />
                  <Route path="notifications" element={<Notifications />} />
                  <Route path="profile" element={<Profile />} />
                  <Route index element={<Navigate to="dashboard" replace />} />
                  <Route path="*" element={<Navigate to="dashboard" replace />} />
                </Route>
                <Route path="/" element={<Navigate to="/admin" replace />} />
              </Routes>
              <Toaster position="top-right" />
            </div>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
